import actions from '../Actions/actions';

const initialState = {
    fetching: false,
    fetched: false,
    error: null,
    statusCode: null,

    age: '', //34,
    birthDate: '', //"1984-10-18T00:00:00",
    canLogin: '', // false,
    canPurchase: '', // false,
    city: '', //"Jönköping",
    coAddress: null,
    country: '', //"Sverige",
    countryCode: '', //6,
    emailAddress: '', //"aktiv1.intesavanligsson.test@solidpark.se",
    faxPhone: null,
    firstName: '', //"Aktiv1",
    foAddress: null,
    gender: '', //"K",
    homePhone: '', //"0380-14674",
    lastName: '', //"Vanligsson",
    mobilePhone: '', // "073-5072025",
    municipalityCode: null, // 680,
    personId: null, // 1212753,
    personalIdentityNumber: '', //"198410188406",
    streetAddress: '', //"Björkvägen 66",
    workPhone: null, // 1234567
    zipCode: null, //55313,
    zipCodeArea: '', // "553 Jönköping"
};

export default function customerInfo(state = initialState, action = {}) {
    let returnState = {...state};

    switch (action.type) {
        case actions.CUSTOMER_INFO_FETCHING_SET:
            returnState = {
                ...state,
                fetching: !!action.payload
            };
            break;
        case actions.CUSTOMER_INFO_SET:
            returnState = {
                ...state,
                ...action.payload
            };
            break;
    }

    return returnState;
}